module.exports = __webpack_public_path__ + "images/2c7e5d108cee9187d7c1472fae258d4b.jpg";